import { render, staticRenderFns } from "./userInfo_teamScoreSearch.vue?vue&type=template&id=5dc1dbb5&"
import script from "./userInfo_teamScoreSearch.vue?vue&type=script&lang=js&"
export * from "./userInfo_teamScoreSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports